import { type ReactNode } from 'react'

interface SettingsGroupProps {
  label: ReactNode
  action?: ReactNode
  children: ReactNode
  'data-onboarding-target'?: string
}

export function SettingsGroup({ label, action, children, 'data-onboarding-target': onboardingTarget }: SettingsGroupProps) {
  return (
    <div className="space-y-3" data-onboarding-target={onboardingTarget}>
      <div className="flex items-center justify-between gap-4">
        <h3 className="text-sm font-medium text-muted-foreground/80">{label}</h3>
        {action}
      </div>
      <div className="rounded-[0.625rem] overflow-hidden">
        <div className="flex flex-col gap-1">
          {children}
        </div>
      </div>
    </div>
  )
}
